export class ReportModel {
    public id: any;
    public reportName: string;
    public reportDesc: string;
    public reportSql: string;
    public status: string;
    public reportType: string;
    public category: string;
    public distList: string;
    public distName: string;
    public distId: number;
    public sqlParams: string;
    public sqlLabels: string;
    public instanceName: string;
    public scheduleStr: string
    constructor(
    ) {
        this.id = null;
        this.reportName = null;
        this.reportDesc = null;
        this.reportSql = null;
        this.status = null;
        this.reportType = null;
        this.category = null;
        this.distList = null;
        this.distName = null;
        this.distId = null;
        this.sqlParams = null;
        this.sqlLabels = null;
        this.instanceName = null;
        this.scheduleStr = null;
    }
}
